export default [
  { id: 'USD', name: 'USD - US Dollar' },
];
